import { Component, OnInit, ViewChild, OnDestroy } from '@angular/core';
import { TableSearchPipe } from './../../../../pipes/table-search.pipe';
import { VendorService } from './../../../../services/vendor.service';
import { VendorDetailsViewModel } from './../../../../models/VendorDetailsViewModel';
import { Router, ActivatedRoute } from '@angular/router';
import { DataService } from './../../../../services/data.service';
import { PurchaseOrder } from '../../../../models/PurchaseOrder';
import { ModalComponent } from '../../../../shared-components/modal/modal.component';
import { VendorStatementComponent } from '../vendor-statement/vendor-statement.component';
import { VendorDocument } from '../../../../models/VendorDocument';
import { EmailService } from '../../../../services/email.service';
import { SubmitVendorInvoiceComponent } from '../invoices-view/submit-vendor-invoice/submit-vendor-invoice.component';
import { PowerBireportComponent } from '../../../../shared-components/power-bireport/power-bireport.component';
import { NgxSpinnerService } from 'ngx-spinner';
@Component({
  selector: 'app-vendor-home',
  templateUrl: './vendor-home.component.html',
  styleUrls: ['./vendor-home.component.scss']
})
export class VendorHomeComponent implements OnInit, OnDestroy {
  purchaseordersPg:number = 1;
  selectedPoPerPageVal = '5 per page';
  purchaseordersFilter:string = '';
  purchaseorders:PurchaseOrder[];
  poSortBy:any = 'Date';
  poSortOrder:string = 'asc';
  invoicePg:number = 1;
  selectedInvePerPageVal = '5 per page';
  invoices:any = [];
  invoicesFilter:string = 'Open';
  invSortBy:any = '';
  invSortOrder:string = 'asc';
  userInfo:any;
  data:any;
  selectedPONumber: string;
  vendorDoc: VendorDocument;
  public ItmPerPage: any = [{ id: 1, name: '5', value: '5 per page' },
  { id: 2, name: '10', value: '10 per page' },
  { id: 3, name: '25', value: '25 per page' },
  { id: 4, name: '50', value: '50 per page' }];
  @ViewChild('templatePODetails') templatePODetails: ModalComponent;
  @ViewChild('templateSubmitStmt') templateSubmitStmt: ModalComponent;
  @ViewChild('templateSubmitInvoice') templateSubmitInvoice: ModalComponent;
  @ViewChild('vendorStmt') vendorStmt: VendorStatementComponent;
  @ViewChild('vendorInv') vendorInv: SubmitVendorInvoiceComponent;
 // @ViewChild('powerBI') PowerBIreport: PowerBireportComponent;
  private alive = true;

  constructor(private datasvc: DataService, private vendorsvc: VendorService, private router: Router, private _spinner: NgxSpinnerService,
    private emailSvc: EmailService ) {

   }

  ngOnInit() {
    this.userInfo = this.datasvc.userDisplayInfo;
    this.vendorsvc.getVendorHomeInfo().takeWhile(() => this.alive).subscribe(
      data => {
        this.data = data;
        console.log('Vendor data', this.data);
        this.purchaseorders = this.data.VendorPOList;
        this.invoices = this.data.VendorInvList;
        console.log('Vendor data', this.purchaseorders);

      });
  }

  ngOnDestroy() {
    this.alive = false;
  }

  submitInvoice() {
    this.router.navigate(['/']);
  }

  showPODetails(poNumber: string) {
    
    this.selectedPONumber = poNumber;
    this.templatePODetails.show();
  }
  getInvoiceDetails(invNumber: string) {

      this.vendorDoc = new VendorDocument();
        this.vendorsvc.getInvoiceDetails(invNumber, this.userInfo.GPVID).takeWhile(() => this.alive).subscribe(
          data => {
            this.vendorDoc = data;
            console.log('Vendor data', this.vendorDoc);

          });

    }

    getPdfFile(poNumber: string) {
      // Open window first to prevent ad blocker coming into play
      const loWinExt = window.open();
        //this._spinner.show();
        this.emailSvc.ExportReportToPDF(poNumber,"","","")
        .takeWhile(() => this.alive)
        .subscribe(
          data => {
           // this._spinner.hide();
            console.log('report'+data);
            const byteCharacters = atob(data);
            const byteNumbers = Array.from(byteCharacters, (char) => char.charCodeAt(0));
            const byteArray = new Uint8Array(byteNumbers);
            const blob = new Blob([byteArray], { type: 'application/pdf' });
            const url = window.URL.createObjectURL(blob);
            const link = document.createElement('a');
            link.href = url;
            link.download = poNumber+'.pdf'; // File name for download
            link.target='_blank';
            link.click();
            if(loWinExt)
            {
              loWinExt.close();
            }
          
            // if (loWinExt) {
            //   loWinExt.location.href =  data;
            // } else {
            //   window.open(data, '_blank');
            // }
          },
          err => {
            this._spinner.hide();
            console.log(err);
          }
          
        );
        // if(loWinExt)
        //   {
        //     loWinExt.close();
        //   }
    }
  submitStatement() {
    this.router.navigate(['/']);
  }
  showVendorStmt() {
    this.vendorStmt.clearData();
    this.templateSubmitStmt.show();
  }

  showVendorInvoice() {
    this.vendorInv.clearData();
    this.templateSubmitInvoice.show();
  }

}



// WEBPACK FOOTER //
// ./src/app/pages/vendor/my-vendor/vendor-home/vendor-home.component.ts